/* istanbul ignore file */

// deps
import { Box, Image, Text } from "@chakra-ui/react";
import { RendererContext } from "@splitfire-agency/raiden-le-editeur/dist/renderers";
import PropTypes from "prop-types";
import { useContext, useState } from "react";

// libraries
import { useIntl } from "react-intl";
import { filesGetSrc } from "../../../helpers/files";
import generateAdminUri from "../../../libraries/utils/generateAdminUri";

export function FilesEditorImageBlockChakra(props) {
  const { block } = props;

  const { document, language } = useContext(RendererContext);

  const content =
    block.content.intl[language.key] ?? block.content.intl[document.language];

  const [hasError, setHasError] = useState(false);

  const intl = useIntl();

  return (
    <>
      {hasError || !content?.src ? (
        <Image
          src={generateAdminUri({
            id: "internal-assets",
            parameters: {
              filePath: "splashes/default.png",
            },
            includeBasePath: true,
          })}
          alt={intl.formatMessage({ defaultMessage: "Placeholder" })}
        />
      ) : (
        <Box>
          <Image
            alt={content?.alt}
            title={content?.name}
            onLoad={function () {
              setHasError(false);
            }}
            onError={function () {
              setHasError(true);
            }}
            src={filesGetSrc({ content })}
          />

          {content?.caption && <Text mt="0.5rem">{content.caption}</Text>}
        </Box>
      )}
    </>
  );
}

FilesEditorImageBlockChakra.propTypes = {
  block: PropTypes.object,
};
